import { reportColumnAggregateTypesEnum } from "helpers/enums";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import compact from "lodash/compact";
import mean from "lodash/mean";
import sum from "lodash/sum";
import React from "react";
import { OverallReport } from "./overallReport";

export default class OverallReportWithVat extends OverallReport {
    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            Cell: (props) => {
                switch (props.column.id) {
                    case "emptyMileageWithoutEmptyMileageBid": {
                        const { emptyMileageWithoutEmptyMileageBidRating } = props.row;
                        return `${formatValue(props.value, column.clrType)} (${formatValue(
                            emptyMileageWithoutEmptyMileageBidRating / 100,
                            "percent",
                        )})`;
                    }
                    case "emptyMileageBid": {
                        const { emptyMileageBidRating } = props.row;
                        return `${formatValue(props.value, column.clrType)} (${formatValue(emptyMileageBidRating / 100, "percent")})`;
                    }
                    case "carLogistId": {
                        const { subRows } = props.row;
                        const logistName = subRows[0].original.carLogistDisplayName || "Без логиста";
                        const rowCount = /\(\d+\)$/.test(logistName) ? "" : ` (${subRows.length})`;
                        return `${logistName}${rowCount}`;
                    }
                    default:
                        return formatValue(props.value, column.clrType);
                }
            },
            Footer: () => {
                const defaultFooter = this.footerVal(column);
                const { footer } = this.props.data || {};
                switch (column.propertyName) {
                    case "EmptyMileageWithoutEmptyMileageBid": {
                        const { emptyMileageWithoutEmptyMileageBidRating } = footer;
                        return [
                            <span key="value">{defaultFooter}</span>,
                            <span key="rating">
                                {" "}
                                ({formatValue(emptyMileageWithoutEmptyMileageBidRating / 100, "percent")})
                            </span>,
                        ];
                    }
                    case "EmptyMileageBid": {
                        const { emptyMileageBidRating } = footer;
                        return [
                            <span key="value">{defaultFooter}</span>,
                            <span key="rating"> ({formatValue(emptyMileageBidRating / 100, "percent")})</span>,
                        ];
                    }
                    default:
                        return defaultFooter;
                }
            },
            ...typeSpecificProps(column),
        };
    };

    extractColumns = () => {
        const { columns } = this.props.data || {};

        return compact(
            columns.map((column) => {
                if (!column.label) {
                    return null;
                }
                return {
                    ...this.cellProps(column),
                    aggregate: (values) => {
                        if (!this.numericClrTypes.includes(column.clrType)) {
                            return null;
                        }
                        switch (column.aggregateType) {
                            case reportColumnAggregateTypesEnum.Average:
                                return Math.round(mean(values));
                            case reportColumnAggregateTypesEnum.Sum:
                                return sum(values);
                            default:
                                return null;
                        }
                    },
                    Aggregated: ({ value, row }) => {
                        switch (column.propertyName) {
                            case "Output": {
                                const { overallBidsPrice, overallMileage } = row.values;
                                const output = overallMileage === 0 ? 0 : overallBidsPrice / overallMileage;
                                return <strong>{formatValue(output, column.clrType)}</strong>;
                            }
                            case "EmptyMileageBid": {
                                const { overallMileage, emptyMileageBid } = row.values;
                                if (!overallMileage || !emptyMileageBid) {
                                    return (
                                        <strong>
                                            {formatValue(value, column.clrType)} ({formatValue(0, "percent")})
                                        </strong>
                                    );
                                }
                                return (
                                    <strong>{`${formatValue(value, column.clrType)} (${formatValue(
                                        emptyMileageBid / overallMileage,
                                        "percent",
                                    )})`}</strong>
                                );
                            }
                            case "EmptyMileageWithoutEmptyMileageBid": {
                                const { overallMileage, emptyMileageWithoutEmptyMileageBid } = row.values;
                                if (!overallMileage || !emptyMileageWithoutEmptyMileageBid) {
                                    return (
                                        <strong>
                                            {formatValue(value, column.clrType)} ({formatValue(0, "percent")})
                                        </strong>
                                    );
                                }
                                return (
                                    <strong>
                                        {`${formatValue(value, column.clrType)} (${formatValue(
                                            emptyMileageWithoutEmptyMileageBid / overallMileage,
                                            "percent",
                                        )})`}
                                    </strong>
                                );
                            }
                            default:
                                return value !== null ? (
                                    <strong>{formatValue(Math.round(100 * value) / 100, "double")}</strong>
                                ) : (
                                    ""
                                );
                        }
                    },
                };
            }),
        );
    };

    tableExtraProps = () => {
        const { columns } = this.props.data || {};
        const hiddenColumns = columns
            .filter((column) => {
                return (
                    column.isAdditionalColumn || column.isFooterData || column.propertyName === "CarLogistDisplayName"
                );
            })
            .map(columnName);

        return {
            initialState: {
                hiddenColumns,
                groupBy: ["carLogistId"],
            },
        };
    };
}
